// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasOnComplete, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    ApiHandlerDiscreteParameter,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
    ReorderResult,
} from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";

export type ReorderParameter = {
    orderNumber: string;
} & HasOnSuccess<ReorderResult | void> &
    HasOnComplete<{ apiResult: ReorderResult }> &
    HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<ReorderParameter, CartLineCollectionModel, ReorderResult>;

export const XngExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
